export default __webpack_public_path__ + "static/media/O-019.b87e21a2.png";